import { create } from 'zustand';

import { RtcComponent, SessionsObj } from './RtcComponent';
import { TauriRtcComponent } from './TauriRtcComponent';

interface SessionsStoreProps {
    publicDiscovery: boolean | null;
    rtc: RtcComponent | TauriRtcComponent | null;
    sessions: SessionsObj | null;
    setPublicDiscovery: (val: boolean) => void;
    setSessions: (sessions: SessionsObj) => void;
}

export const useSessionsStore = create<SessionsStoreProps>((set, get) => ({
    publicDiscovery: null,
    rtc: null,
    sessions: null,
    setPublicDiscovery: (val) => {
        localStorage.setItem('publicDiscovery', val.toString());
        set({ publicDiscovery: val });
        const rtc = get().rtc;
        if (rtc) {
            rtc.setPublicDiscovery(val);
        }
    },
    setSessions: (sessions) => set({ sessions: sessions }),
}));
